export default __webpack_public_path__ + "static/media/cont-about.d6b1d231.png";